import { TIME_ZONE, TIME_ZONES } from '../Controls.constants'

import { radioGroup } from './index'

/**
 * @param {string} name
 * @param {string} value
 * @param {Iterable<string>} options
 */
export function timeZone(name, value = TIME_ZONE.VIENNA, options = TIME_ZONES) {
  return radioGroup(name, value, { options })
}
